export default __webpack_public_path__ + "static/media/price.3b911237.svg";